module.exports = __webpack_public_path__ + "img/entertainment-m-1.ea0ec9e5.jpg";